import "./ActivitiesHeader.scss";
import React from 'react';

const ActivitiesHeader = () => {
  return (
    <header className="about-acts__header">
      <div className="about-acts__headerGlass">
        <p className="about-acts__kicker">GIST Official Student Ambassadors</p>
        <h1 className="about-acts__title">지온나래 활동</h1>
        <p className="about-acts__sub">
          투어·콘텐츠·행사 지원까지, <br className="m-only" />
          학교의 순간을 더 가까이 전합니다.
        </p>
      </div>
    </header>
  );
};

export default ActivitiesHeader;